import React from 'react';
import Grid from '@mui/material/Grid';
import publishedMap from '../assets/images/publishedMap.svg';
import draftMap from '../assets/images/draftmap.png';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import {Link} from 'react-router-dom';
import CircleIcon from '@mui/icons-material/Circle';
import {CheckCircleOutline, Error} from '@mui/icons-material';
import {Checkbox} from '@mui/material';
import {Language} from '../context/LanguageContext';
import '../assets/styles/mapFiles.scss';
const MapFiles = (props) => {
  const centerLat = props.file.latitude;
  const centerLong = props.file.longitude;
  const projekCode = props.file.kodKawasa;
  const handleRenderUploadItem = (bool, text) => {
    if (!bool) {
      return (
        <div className='upload_item unavailable'>
          <Error htmlColor='#2F5481' />
          <p
            style={{
              color: '#4872A5',
            }}
          >
            {text}
          </p>
        </div>
      );
    } else {
      return (
        <div className='upload_item'>
          <CheckCircleOutline htmlColor='#6CFF00' />
          <p>{text}</p>
        </div>
      );
    }
  };
  return (
    <>
      <Grid item xs={12} sm={6} md={4} lg={3} onClick={() => props?.onClick()}>
        <div className={`mapfile_ctr ${props.isPublished ? 'published' : ''}`}>
          <Box
            sx={{
              // background: `${props.isPublished ? '#2B5180' : 'white'}`,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'space-between',
              width: '100%',
              borderRadius: '10px',
              textAlign: 'start',
            }}
          >
            {props.isPublished ? (
              <Box
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  fontWeight: 'bold',
                  fontSize: '12px',
                  color: `${
                    props.isPublished ? 'white !important' : 'black !important'
                  }`,
                }}
              >
                <Avatar
                  src={props.isPublished ? publishedMap : draftMap}
                  style={{
                    background: 'transparent',
                    borderRadius: 0,
                    color: 'white',
                    objectFit: 'contain',
                    width: 'fit-content',
                    height: '60px',
                    aspectRatio: 1,
                    marginRight: 5,
                  }}
                />
                {props.title}
              </Box>
            ) : (
              <Link to={`/mappreview?center=${centerLat + '&' + centerLong}`}>
                <Box
                  sx={{
                    display: 'flex',
                    alignItems: 'center',
                    fontWeight: 'bold',
                    cursor: 'pointer',
                    fontSize: '12px',
                    color: `${
                      props.isPublished
                        ? 'white !important'
                        : 'black !important'
                    }`,
                  }}
                >
                  <Avatar
                    src={props.isPublished ? publishedMap : draftMap}
                    style={{
                      background: 'transparent',
                      borderRadius: 0,
                      color: 'white',
                      objectFit: 'contain',
                      width: 'fit-content',
                      height: '60px',
                      aspectRatio: 1,
                      marginRight: 5,
                    }}
                  />
                  {props.title}
                </Box>
              </Link>
            )}

            <div
              style={{
                // backgroundColor: 'rgb(0,0,0,0.3)',
                padding: '20px',
                borderRadius: '0 10px 10px  0 ',
              }}
            >
              <Checkbox
                id={props.id}
                checked={props.checked}
                onClick={(e) => props.onSelectionChange(e)}
                icon={
                  <CircleIcon
                    style={{color: 'white', width: '20px', height: '20px'}}
                  />
                }
                checkedIcon={
                  <CircleIcon
                    style={{
                      color: 'blue',
                      border: 'white 5px solid',
                      borderRadius: '50%',
                      width: '20px',
                      height: '20px',
                    }}
                  />
                }
                color='primary'
                shape='circle'
              />
            </div>
          </Box>
          <div className='mapfile_upload'>
            {props?.isPublished ? (
              <>
                {handleRenderUploadItem(props?.file?.rasterKey, 'Raster')}
                {handleRenderUploadItem(
                  props?.file?.dirianPokokKey,
                  'Dirian Pokok'
                )}
              </>
            ) : (
              <div className='upload_item'>
                <Error
                  htmlColor='#FFEDC6'
                  style={{
                    border: '2px solid #FFAF02',
                    borderRadius: '50%',
                  }}
                />
                <p>Publish Map</p>
              </div>
            )}
          </div>
        </div>
      </Grid>
    </>
  );
};

export default MapFiles;
